import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";

@Injectable()
export class GenericService {
  private url = `/api`;

  constructor(private http: HttpClient) {}

  public find<T>(api: string, paramCustoms?: {}): Observable<[T]> {
    let params = new HttpParams()
      .set("size", "page")
      .set("size", "50")
      .set("sortName", "id")
      .set("sortType", "DESC");

    if (paramCustoms) {
      //   console.log('yesss', paramCustoms, Object.keys(paramCustoms));
      Object.keys(paramCustoms).forEach(key => {
        params = params.set(key, paramCustoms[key]);
        console.log("key", key, "value", paramCustoms[key]);
      });
    }

    return this.http.get<[T]>(`${this.url}/${api}`, { params: params });
  }

  public get<T>(api: string, paramCustoms?: {}): Observable<T> {
    let params = new HttpParams();

    if (paramCustoms) {
      //   console.log('yesss', paramCustoms, Object.keys(paramCustoms));
      Object.keys(paramCustoms).forEach(key => {
        params = params.set(key, paramCustoms[key]);
        console.log("key", key, "value", paramCustoms[key]);
      });
    }

    return this.http.get<T>(`${this.url}/${api}`, { params: params });
  }

  public getByid<T>(api: string, id: number): Observable<T> {
    return this.http.get<T>(`${this.url}/${api}/${id}`);
  }

  create<T>(api: string, object: T) {
    return this.http.post(`${this.url}/${api}`, object).map(data => {
      console.log(data);
    });
  }
  /**
   * supprimmer un object
   * @param api
   * @param object
   */
  delete<T>(api: string, object: T) {
    return this.http.delete(`${this.url}/${api}/${object["id"]}`).map(data => {
      console.log(data);
    });
  }
  /**
   * for update object
   * @param api : api service object exemple types; postes
   * @param object : a updated
   */
  update<T>(api: string, object: T) {
    return this.http
      .put(`${this.url}/${api}/${object["id"]}`, object)
      .map(data => {
        console.log(data);
      });
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/generic.service.ts